module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section gallery"
  }, [_c('div', {
    staticClass: "gallery--intro rich-text",
    domProps: {
      "innerHTML": _vm._s(_vm.content.text)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gallery--widget"
  }, [(!_vm.hasImages) ? _c('p', {
    staticClass: "gallery--empty-message",
    domProps: {
      "textContent": _vm._s(_vm.content.no_images_message)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isMobile && _vm.hasImages) ? _c('div', {
    staticClass: "gallery--preview"
  }, [_c(_vm.previewComponent.type, {
    tag: "component",
    attrs: {
      "facet": "preview",
      "plugin": _vm.previewComponent,
      "preload": true,
      "resource-name": "image"
    },
    on: {
      "image-clicked": _vm.onOverlayRequested
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasImages) ? _c('div', {
    staticClass: "gallery--carousel"
  }, [_c('cmp-carousel', {
    attrs: {
      "items": _vm.carouselSlides,
      "facet": "gallery",
      "show-arrows": true,
      "show-pagination": false,
      "show-item-count": _vm.isMobile,
      "passive-mode": true,
      "idx": _vm.slideIdx
    },
    on: {
      "request-change": function($event) {
        _vm.updateSlideIdx($event)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_c('div', {
          staticClass: "gallery--carousel-item grid",
          attrs: {
            "data-images-per-slide": _vm.imagesPerSlide
          }
        }, [_c('div', {
          staticClass: "grid--row gallery--carousel-item-row"
        }, _vm._l((props.item), function(plugin, pluginIdx) {
          return _c('div', {
            staticClass: "grid--col gallery--carousel-item-col"
          }, [_c(plugin.type, {
            tag: "component",
            attrs: {
              "plugin": plugin,
              "preload": plugin.preload,
              "resource-name": _vm.previewResourceName
            },
            on: {
              "image-clicked": function($event) {
                _vm.onImageSelected(props.itemIdx, pluginIdx)
              }
            }
          })], 1)
        }))])]
      }
    }])
  })], 1) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-05d0cdc0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05d0cdc0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-plugins/gallery/index.vue
// module id = 504
// module chunks = 7